import { getImageList, getDate } from "./image-list.js";

(async function () {
  const gallery = document.getElementById("gallery");
  const modal = document.getElementById("modal");
  const modalImg = document.getElementById("modal-img");
  const modalClose = document.getElementById("modal-close");
  const loader = document.getElementById("loader");

  const openModal = (src) => {
    modalImg.src = src;
    modal.classList.remove("hidden");
  };

  const closeModal = () => {
    modal.classList.add("hidden");
    modalImg.src = "";
  };

  modalClose.addEventListener("click", closeModal);

  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  document.getElementById("gallery").addEventListener("click", (e) => {
    if (e.target.tagName === "IMG") openModal(e.target.src);
  });

  if (gallery.querySelector("img")) return;

  const renderGallery = (images) => {
    if (!images?.length) return;

    const container = document.getElementById("gallery");
    const fragment = document.createDocumentFragment();

    let eagerLoadCount;
    if (window.innerWidth < 768) {
      eagerLoadCount = 2;
    } else {
      eagerLoadCount = 4;
    }

    images.forEach((image, idx) => {
      const wrapper = document.createElement("div");
      const button = document.createElement("button");
      const text = document.createElement("p");
      const img = document.createElement("img");
      img.onload = () => {
        text.innerText = getDate(image.url);
      };
      img.alt = "Generated AI image";
      if (idx < eagerLoadCount) {
        if (idx === 0) img.fetchPriority = "high";
      } else {
        img.loading = "lazy";
      }
      img.width = "300";
      img.height = "300";
      img.src = image.url;
      button.appendChild(img);
      wrapper.appendChild(button);
      wrapper.appendChild(text);
      fragment.appendChild(wrapper);
    });

    container.appendChild(fragment);
  };

  try {
    const images = await getImageList();

    loader.style.display = "none";
    gallery.removeAttribute("style");

    if (images?.length > 1) {
      renderGallery(images.slice(1));
    } else {
      gallery.innerHTML = "<p>No archived images yet.</p>";
    }
  } catch (error) {
    gallery.innerHTML = "<p>Failed to load archive.</p>";
  }
})();
